<template lang="pug">
div
  v-list-tile(@click="select" :to="{name:'ReportList'}" ripple)
    v-list-tile-action.pl-0
      v-icon insert_chart
    v-list-tile-content
      v-list-tile-title {{ $tf("drawer.report.title") }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ReportDrawer',

  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
    }),

    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/report/ReportDrawer.vue